<template>
  <login-component-layout component="LoginCardSet">
    <div v-if="!($route.query.code || $route.params.code)">
      {{ $t("components.login.LoginCardSet.instructions") }}
    </div>
    <div v-else>
      {{ $t("components.login.LoginCardSet.shortInstructions") }}
    </div>
    <v-form v-model="isFormValid" @submit.prevent="submit" class="mt-7">
      <login-component-input-mail />
      <login-component-input-password :onlyRequired="true" />
      <login-component-input-password suffix="New" :rule="passwordNewRule" />
      <login-component-input-password suffix="Repeat" :rule="passwordRepeatRule" />
      <login-component-password-requirement-list :password="passwordNew" :setPass="setPass" />
      <login-component-message :failText="failText" :successText="successText" />
      <login-component-submit-button :isLoading="isLoading" :isFormValid="isFormValid" component="LoginCardSet" />
      <login-component-navigation-button to="/login" />
    </v-form>
  </login-component-layout>
</template>

<script lang="ts">
import { Component, Mixins } from "vue-property-decorator";
import { UserModule } from "@/store/modules/me-user.store";
import { LoginModule } from "@/store/modules/login.store";
import { MrfiktivChangePasswordIfRequiredDtoGen as ChangePasswordIfRequiredDto } from "@/services/mrfiktiv/v1/data-contracts";
import LoginMixin from "@/mixins/LoginMixin.vue";
import LoginNewPasswordMixin from "@/mixins/LoginNewPasswordMixin.vue";
import LoginComponentPasswordRequirementList from "@/components/login/LoginComponentPasswordRequirementList.vue";
import LoginComponentInputMail from "@/components/login/LoginComponentInputMail.vue";
import LoginComponentInputPassword from "@/components/login/LoginComponentInputPassword.vue";
import LoginComponentMessage from "@/components/login/LoginComponentMessage.vue";
import LoginComponentNavigationButton from "@/components/login/LoginComponentNavigationButton.vue";
import LoginComponentSubmitButton from "@/components/login/LoginComponentSubmitButton.vue";
import LoginComponentLayout from "@/components/login/LoginComponentLayout.vue";
import LoginErrorMixin from "@/mixins/LoginErrorMixin.vue";
import { IFailureCodeContent } from "@/mixins/LoginErrorMixin.vue";

@Component({
  components: {
    LoginComponentPasswordRequirementList,
    LoginComponentInputMail,
    LoginComponentInputPassword,
    LoginComponentMessage,
    LoginComponentNavigationButton,
    LoginComponentSubmitButton,
    LoginComponentLayout
  }
})
export default class LoginCardSet extends Mixins(LoginMixin, LoginNewPasswordMixin, LoginErrorMixin) {
  beforeMount() {
    LoginModule.setPasswordNew("");
    LoginModule.setPasswordRepeat("");
  }

  customFailure = new Map<string, IFailureCodeContent>([
    [
      "Passwordchange is not forced.",
      {
        message: "components.login.LoginCardSet.failNotRequired",
        onFail: () => {
          this.setFormInvalid();
        }
      }
    ]
  ]);

  mounted() {
    this.registerCustomFailureCodes(this.customFailure);
  }

  /*
   * Set password on first login
   */
  async submit() {
    const changePasswordIfRequired: ChangePasswordIfRequiredDto = {
      previousPassword: this.password,
      proposedPassword: this.passwordRepeat,
      username: this.mail
    };
    try {
      this.isLoading = true;
      await UserModule.changePasswordIfRequired(changePasswordIfRequired);
      this.checkIfUserIsLoggedInAndRedirect();
    } catch (error) {
      this.handleFail(error);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>

<style scoped>
.bold {
  font-weight: 900;
}
</style>
